import { useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * One-time announcement for the 2026-07 AI upgrade. Dismissal is remembered in
 * localStorage (per browser) and hides it everywhere it's mounted. Bump the KEY
 * for a future announcement; remove the component when it has run its course.
 */
const KEY = 'cs-callout-ai-star-2026-07';

export function AiStarCallout({ onAssistantPage = false }: { onAssistantPage?: boolean }) {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(KEY) === '1');
  if (dismissed) return null;
  const dismiss = () => {
    localStorage.setItem(KEY, '1');
    setDismissed(true);
  };
  return (
    <div className="relative mb-4 overflow-hidden rounded-2xl border border-emerald-200 bg-gradient-to-r from-emerald-50 via-white to-emerald-50 p-4 shadow-sm dark:border-emerald-900/60 dark:from-emerald-950/40 dark:via-neutral-950 dark:to-emerald-950/40">
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        title="Dismiss — you won't see this again"
        className="absolute right-3 top-3 rounded-full p-1 text-neutral-400 transition hover:bg-neutral-100 hover:text-neutral-600 dark:hover:bg-neutral-800"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M6 6l12 12M18 6L6 18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>
      <p className="pr-8 text-sm font-semibold text-emerald-800 dark:text-emerald-300">
        ✨ Your AI assistant just got dramatically smarter
      </p>
      <p className="mt-1 pr-8 text-sm leading-relaxed text-neutral-600 dark:text-neutral-300">
        Every answer is now written by a frontier AI model. Ask about anything — chargebacks,
        payment gaps, attrition, carrier scorecards, renewal forecasts, book value — and watch it
        work in real time. Conversations are remembered, and “Investigate deeper” digs through your
        book step by step.
      </p>
      <div className="mt-2.5 flex flex-wrap items-center gap-3 text-sm">
        {!onAssistantPage && (
          <Link
            to="/assistant"
            className="rounded-full bg-emerald-600 px-3.5 py-1.5 font-medium text-white transition hover:bg-emerald-700"
          >
            Try Ask AI →
          </Link>
        )}
        <Link
          to="/profile"
          className="text-emerald-700 underline-offset-2 hover:underline dark:text-emerald-400"
        >
          Prefer your own AI key? Add it under Profile → AI key
        </Link>
      </div>
    </div>
  );
}
